import { render, staticRenderFns } from "./TableRowActions.vue?vue&type=template&id=31c49f87&scoped=true"
import script from "./TableRowActions.vue?vue&type=script&lang=js"
export * from "./TableRowActions.vue?vue&type=script&lang=js"
import style0 from "./TableRowActions.vue?vue&type=style&index=0&id=31c49f87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c49f87",
  null
  
)

export default component.exports